/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TemperatureSensor,
    TemperatureSensorFromJSON,
    TemperatureSensorFromJSONTyped,
    TemperatureSensorToJSON,
} from './';

/**
 * 
 * @export
 * @interface WriteOnlyMonitoredObject
 */
export interface WriteOnlyMonitoredObject {
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    clientId: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    monitoredObjectTypeId?: number;
    /**
     * 
     * @type {object}
     * @memberof WriteOnlyMonitoredObject
     */
    costPerKm?: object;
    /**
     * 
     * @type {Array<TemperatureSensor>}
     * @memberof WriteOnlyMonitoredObject
     */
    temperatureSensors?: Array<TemperatureSensor>;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    systemDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    manufacturerName?: string | null;
    /**
     * 
     * @type {object}
     * @memberof WriteOnlyMonitoredObject
     */
    _configuration?: object | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    tankSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    customLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    vehicleTrainMaxWeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    vehicleTractorMaxWeight?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WriteOnlyMonitoredObject
     */
    cng?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyMonitoredObject
     */
    disabledAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof WriteOnlyMonitoredObject
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyMonitoredObject
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMonitoredObject
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    monitoringDevice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    driverApplication?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    externalSystem?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMonitoredObject
     */
    countryOfRegistration?: number | null;
}

export function WriteOnlyMonitoredObjectFromJSON(json: any): WriteOnlyMonitoredObject {
    return WriteOnlyMonitoredObjectFromJSONTyped(json, false);
}

export function WriteOnlyMonitoredObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyMonitoredObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['client_id'],
        'monitoredObjectTypeId': !exists(json, 'monitored_object_type_id') ? undefined : json['monitored_object_type_id'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'temperatureSensors': !exists(json, 'temperature_sensors') ? undefined : ((json['temperature_sensors'] as Array<any>).map(TemperatureSensorFromJSON)),
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'registrationNumber': json['registration_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'systemDescription': !exists(json, 'system_description') ? undefined : json['system_description'],
        'manufacturerName': !exists(json, 'manufacturer_name') ? undefined : json['manufacturer_name'],
        '_configuration': !exists(json, 'configuration') ? undefined : json['configuration'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tankSize': !exists(json, 'tank_size') ? undefined : json['tank_size'],
        'customLabel': !exists(json, 'custom_label') ? undefined : json['custom_label'],
        'vehicleTrainMaxWeight': !exists(json, 'vehicle_train_max_weight') ? undefined : json['vehicle_train_max_weight'],
        'vehicleTractorMaxWeight': !exists(json, 'vehicle_tractor_max_weight') ? undefined : json['vehicle_tractor_max_weight'],
        'cng': !exists(json, 'cng') ? undefined : json['cng'],
        'disabledAt': !exists(json, 'disabled_at') ? undefined : (json['disabled_at'] === null ? null : new Date(json['disabled_at'])),
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'monitoringDevice': !exists(json, 'monitoring_device') ? undefined : json['monitoring_device'],
        'driverApplication': !exists(json, 'driver_application') ? undefined : json['driver_application'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'countryOfRegistration': !exists(json, 'country_of_registration') ? undefined : json['country_of_registration'],
    };
}

export function WriteOnlyMonitoredObjectToJSON(value?: WriteOnlyMonitoredObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'monitored_object_type_id': value.monitoredObjectTypeId,
        'cost_per_km': value.costPerKm,
        'temperature_sensors': value.temperatureSensors === undefined ? undefined : ((value.temperatureSensors as Array<any>).map(TemperatureSensorToJSON)),
        'external_id': value.externalId,
        'registration_number': value.registrationNumber,
        'description': value.description,
        'system_description': value.systemDescription,
        'manufacturer_name': value.manufacturerName,
        'configuration': value._configuration,
        'note': value.note,
        'status': value.status,
        'tank_size': value.tankSize,
        'custom_label': value.customLabel,
        'vehicle_train_max_weight': value.vehicleTrainMaxWeight,
        'vehicle_tractor_max_weight': value.vehicleTractorMaxWeight,
        'cng': value.cng,
        'disabled_at': value.disabledAt === undefined ? undefined : (value.disabledAt === null ? null : value.disabledAt.toISOString()),
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'monitoring_device': value.monitoringDevice,
        'driver_application': value.driverApplication,
        'external_system': value.externalSystem,
        'country_of_registration': value.countryOfRegistration,
    };
}


